import { PageId } from 'constants/pages'

export const enum PageIdStylioCapmoms4 {
  AGE_CAPMOMS4 = PageId.AGE_CAPMOMS4,
  URGE_CAPMOMS4 = PageId.URGE_CAPMOMS4,
  HAIR_COLOR_CAPMOMS4 = PageId.HAIR_COLOR_CAPMOMS4,
  EYES_COLOR_CAPMOMS4 = PageId.EYES_COLOR_CAPMOMS4,
  JEWELRY_CAPMOMS4 = PageId.JEWELRY_CAPMOMS4,
  BODY_SHAPE_CAPMOMS4 = PageId.BODY_SHAPE_CAPMOMS4,
  STYLIO_TO_HELP_CAPMOMS4 = PageId.STYLIO_TO_HELP_CAPMOMS4,
  TALL_CAPMOMS4 = PageId.TALL_CAPMOMS4,
  WEIGHT_CAPMOMS4 = PageId.WEIGHT_CAPMOMS4,
  URGE_2_CAPMOMS4 = PageId.URGE_2_CAPMOMS4,
  SHOPPING_CAPMOMS4 = PageId.SHOPPING_CAPMOMS4,
  STYLE_MOST_MATTERS_CAPMOMS4 = PageId.STYLE_MOST_MATTERS_CAPMOMS4,
  FEEL_ABOUT_CAPMOMS4 = PageId.FEEL_ABOUT_CAPMOMS4,
  PERCENTAGE_CAPMOMS4 = PageId.PERCENTAGE_CAPMOMS4,
  FAVORITE_COLORS_CAPMOMS4 = PageId.FAVORITE_COLORS_CAPMOMS4,
  LIKE_OR_DISLIKE_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_CAPMOMS4,
  LIKE_OR_DISLIKE_11_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_11_CAPMOMS4,
  LIKE_OR_DISLIKE_12_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_12_CAPMOMS4,
  LIKE_OR_DISLIKE_13_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_13_CAPMOMS4,
  LIKE_OR_DISLIKE_14_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_14_CAPMOMS4,
  LIKE_OR_DISLIKE_15_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_15_CAPMOMS4,
  LIKE_OR_DISLIKE_16_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_16_CAPMOMS4,
  LIKE_OR_DISLIKE_17_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_17_CAPMOMS4,
  LIKE_OR_DISLIKE_18_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_18_CAPMOMS4,
  LIKE_OR_DISLIKE_19_CAPMOMS4 = PageId.LIKE_OR_DISLIKE_19_CAPMOMS4,
  STYLES_FEEL_LIKE_YOU_CAPMOMS4 = PageId.STYLES_FEEL_LIKE_YOU_CAPMOMS4,
  URGE_4_CAPMOMS4 = PageId.URGE_4_CAPMOMS4,
  TIME_CAPMOMS4 = PageId.TIME_CAPMOMS4,
  TYPICAL_DAY_CAPMOMS4 = PageId.TYPICAL_DAY_CAPMOMS4,
  BRAND_CAPMOMS4 = PageId.BRAND_CAPMOMS4,
  FIND_NEW_CLOTHES_CAPMOMS4 = PageId.FIND_NEW_CLOTHES_CAPMOMS4,
  NOTHING_TO_WEAR_CAPMOMS4 = PageId.NOTHING_TO_WEAR_CAPMOMS4,
  OLD_CLOTHES_CAPMOMS4 = PageId.OLD_CLOTHES_CAPMOMS4,
  COMBINE_CLOTHES_CAPMOMS4 = PageId.COMBINE_CLOTHES_CAPMOMS4,
  OPTIMIZE_BUDGET_CAPMOMS4 = PageId.OPTIMIZE_BUDGET_CAPMOMS4,
  URGE_3_CAPMOMS4 = PageId.URGE_3_CAPMOMS4,
  PREPARE_FLOW_CAPMOMS4 = PageId.PREPARE_FLOW_CAPMOMS4,
  EMAIL_CAPMOMS4 = PageId.EMAIL_CAPMOMS4,
  EMAIL_CONSENT_CAPMOMS4 = PageId.EMAIL_CONSENT_CAPMOMS4,
  PRE_PAYWALL_OFFER_CAPMOMS4 = PageId.PRE_PAYWALL_OFFER_CAPMOMS4,
  SUBSCRIPTIONS_CAPMOMS4 = PageId.SUBSCRIPTIONS_CAPMOMS4,
  CANCEL_OFFER_CAPMOMS4 = PageId.CANCEL_OFFER_CAPMOMS4,
  SUB_UPSELL_CAPMOMS4 = PageId.SUB_UPSELL_CAPMOMS4,
  UPSELL_CAPMOMS4 = PageId.UPSELL_CAPMOMS4,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPMOMS4 = PageId.DOWNLOAD_CAPMOMS4,
}
